<template src="./TopBar.html"></template>
<style lang="scss" scoped src="./TopBar.scss"></style>

<script>
import {SfButton} from '@storefront-ui/vue';

export default {
  name: 'TopBar',
  components: {
    SfButton
  },
  computed: {
    user: {
      get() {
        return this.$store.getters.getProfile
      }
    },
    isAuthenticated: {
      get() {
        return this.$store.getters.isAuthenticated
      }
    },
    locale: {
      get() {
        return this.$i18n.locale
      }
    }
  },
};
</script>
